var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAllFromCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 2.8H2.8C2.32261 2.8 1.86477 2.98964 1.52721 3.32721C1.18964 3.66477 1 4.12261 1 4.6V15.4C1 15.8774 1.18964 16.3352 1.52721 16.6728C1.86477 17.0104 2.32261 17.2 2.8 17.2H9.1M12.7 2.8H13.6C14.0774 2.8 14.5352 2.98964 14.8728 3.32721C15.2104 3.66477 15.4 4.12261 15.4 4.6V5.5M15.4 14.5V15.4C15.4 15.8774 15.2104 16.3352 14.8728 16.6728C14.5352 17.0104 14.0774 17.2 13.6 17.2H12.7M15.4 9.1V10.9M8.2 1V19",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 5.5,
    fill: "#333333",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13H12.75C12.5511 13 12.3603 13.1054 12.2197 13.2929C12.079 13.4804 12 13.7348 12 14C12 14.2652 12.079 14.5196 12.2197 14.7071C12.3603 14.8946 12.5511 15 12.75 15H17.25C17.4489 15 17.6397 14.8946 17.7803 14.7071C17.921 14.5196 18 14.2652 18 14C18 13.7348 17.921 13.4804 17.7803 13.2929C17.6397 13.1054 17.4489 13 17.25 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAllFromCompare);
export default __webpack_public_path__ + "static/media/RemoveAllFromCompare.b08f8408d39efd1d0a682abee5b4d69b.svg";
export { ForwardRef as ReactComponent };